export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14845.1784f98d.jpg";